export const cols = [{
	prop: 'shopname',
	label: '店铺名称',
	width: '120',
	ischoose: false,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '主单据编号',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'orderstatus',
	label: '主订单状态',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'createdate',
	label: '下单时间',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customername',
	label: '客户名称',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'childordertype',
	label: '子单据类型',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'sourcetype',
	label: '子单据来源状态',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'childordernumber',
	label: '子订单编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'childcreatedate',
	label: '子订单时间',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'pcode',
	label: '商品编号',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'packing',
	label: '包装清单',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'matchCode',
	label: '第三方编号',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'paymentnumber',
	label: '第三方支付流水号',
	width: '180',
	ischoose: false,
	align: 'center'
}, {
	prop: 'pname',
	label: '商品名称',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'bigcategoryname',
	label: '店铺级大类',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'smallcategoryname',
	label: '店铺级小类',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'spec',
	label: '规格',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'specCode',
	label: '规格编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'giftFlag',
	label: '是否赠品',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'price',
	label: '单价',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'itemquantity',
	label: '订货数量',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundquantity',
	label: '实退数量',
	ischoose: true,
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'realmoney',
	label: '订货金额',
	width: '120',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'refundmoney',
	label: '实退金额',
	width: '180',
	ischoose: true,
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyername',
	label: '收货人',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buytel',
	label: '联系电话',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'buyeraddress',
	label: '收货地址',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}]
